import React from 'react';

const TextError = ({ text }) => {
  return (
    <div className="ant-form-item-explain ant-form-item-explain-error">
      {text}
    </div>
  );
};

export default TextError;
